import { render, staticRenderFns } from "./test-editor.vue?vue&type=template&id=30fe6218&scoped=true&"
import script from "./test-editor.vue?vue&type=script&lang=js&"
export * from "./test-editor.vue?vue&type=script&lang=js&"
import style0 from "./test-editor.vue?vue&type=style&index=0&id=30fe6218&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fe6218",
  null
  
)

export default component.exports